import { reactive } from "vue";

/**
 * Service for managing booking compliance resolution
 * Encapsulates compliance violation state and resolution logic
 */
export class ComplianceService {
	constructor() {
		this.state = reactive({
			hasComplianceViolation: false,
			coolDownViolation: false,
			coolDownInSeconds: null,
			maxBookingViolation: false,
			maxBookingPerDay: null,
			suspiciousPattern: false,
			originalData: {},
			endpoint: "",
			originalMode: "",
		});
	}

	setComplianceViolation(complianceViolationError) {
		this.state.hasComplianceViolation = true;
		this.state.coolDownViolation = complianceViolationError.coolDownViolation || false;
		this.state.coolDownInSeconds = complianceViolationError.coolDownInSeconds || 0;
		this.state.maxBookingViolation = complianceViolationError.maxBookingViolation || false;
		this.state.maxBookingPerDay = complianceViolationError.maxBookingPerDay || 10000;
		this.state.suspiciousPattern = complianceViolationError.suspiciousPattern || false;
		this.state.originalData = complianceViolationError.originalData || {};
		this.state.endpoint = complianceViolationError.endpoint || "";
		this.state.originalMode = complianceViolationError.originalMode || "";
	}

	clearComplianceViolation() {
		this.state.hasComplianceViolation = false;
		this.state.coolDownViolation = false;
		this.state.coolDownInSeconds = null;
		this.state.maxBookingViolation = false;
		this.state.maxBookingPerDay = null;
		this.state.suspiciousPattern = false;
		this.state.originalData = {};
		this.state.endpoint = "";
		this.state.originalMode = "";
	}

	getComplianceViolationData() {
		return {
			hasComplianceViolation: this.state.hasComplianceViolation,
			coolDownViolation: this.state.coolDownViolation,
			coolDownInSeconds: this.state.coolDownInSeconds,
			maxBookingViolation: this.state.maxBookingViolation,
			maxBookingPerDay: this.state.maxBookingPerDay,
			suspiciousPattern: this.state.suspiciousPattern,
		};
	}

	getOriginalData() {
		return { ...this.state.originalData };
	}
	
	getOriginalMode() {
		return this.state.originalMode;
	}

	getEndpoint() {
		return this.state.endpoint;
	}

	hasActiveComplianceViolation() {
		return this.state.hasComplianceViolation;
	}

	createResolutionData(updatedData) {
		return {
			data: updatedData,
			endpoint: this.state.endpoint,
		};
	}
}

/**
 * Composable for using compliance service in components
 */
export function useComplianceService() {
	const complianceService = new ComplianceService();

	return {
		complianceViolationState: complianceService.state,
		setComplianceViolation: (error) => complianceService.setComplianceViolation(error),
		clearComplianceViolation: () => complianceService.clearComplianceViolation(),
		getComplianceViolationData: () => complianceService.getComplianceViolationData(),
		getOriginalData: () => complianceService.getOriginalData(),
		getOriginalMode: () => complianceService.getOriginalMode(),
		createResolutionData: (data) => complianceService.createResolutionData(data),
		hasActiveComplianceViolation: () => complianceService.hasActiveComplianceViolation(),
	};
}
